import { Box, Checkbox, Radio, TableCell, TableRow } from "@mui/material";
import TableDesign from "../../../../components/common/table/TableDesign";
import FormField from "../../../../components/common/FormField";
import { FC } from "react";
import CustomButton from "../../../../components/common/button/CustomButton";
import { useSelector } from "react-redux";

const RenderSurveyTable: FC<any> = ({
  surveyForm,
  onChangeAction,
  onBlurAction,
  error,
  tableHeadding,
  tableContent,
  fields,
  removeRow = null,
  clearRow = null,
  linkedItems = [],
  disabledAction = false,
  isMaterialsTab = false,
  isResourcesTab = false,
  keyName = "",
}) => {
  const { user } = useSelector((state: any) => state.user);

  const isCustomer = user?.user?.roles[0]?.includes("CUSTOMER");

  const handleIncrement = (idx: number, fieldId: string) => {
    // Never mutate the row object in place - it may be a frozen object
    // (e.g. coming straight from Redux state, which Immer deep-freezes in
    // development). Build a fresh value and let onChangeAction handle the
    // immutable state update instead.
    const currentValue = surveyForm?.[idx]?.[fieldId] || 0;
    const nextValue = currentValue + 1;
    onChangeAction(
      { target: { id: fieldId, value: nextValue } },
      idx,
      "quantity",
    );
  };

  const handleDecrement = (idx: number, fieldId: string) => {
    const currentValue = surveyForm?.[idx]?.[fieldId] || 0;
    if (currentValue > 0) {
      const nextValue = currentValue - 1;
      onChangeAction(
        { target: { id: fieldId, value: nextValue } },
        idx,
        "quantity",
      );
    }
  };

  return (
    <TableDesign
      tableHeadings={
        isResourcesTab || isMaterialsTab
          ? tableHeadding.filter(
              (heading: any) =>
                heading.label !== "Move Equipment" &&
                heading.label !== "Linked Items",
            )
          : tableHeadding
      }
      tableHeadColor="#E5F4F1"
      // pagination={pagination}
      filterOption={null}
      // stickyHeader={true}
      setFilterOption={() => {}}
      extraClass="surveyTabTableContainer estimateTable"
      extraCSS={{ borderRadius: "5px" }}
    >
      <>
        {tableContent && tableContent.length > 0 ? (
          tableContent.map((row: any, idx: number) => (
            <>
              <TableRow key={`${idx}-tr-${keyName}}`}>
                {fields &&
                  fields.length &&
                  fields.map((field: any, fieldIdx: number) => {
                    if (
                      (isResourcesTab || isMaterialsTab) &&
                      field?.id === "linkedItem"
                    ) {
                      return null;
                    }

                    return (
                      <TableCell
                        key={`${idx}-${field?.id || fieldIdx}`}
                        sx={{
                          width: field?.width || "auto",
                          whiteSpace: "nowrap",
                          borderRight: "1px solid #CFCFCF",
                          padding: "8px 10px",
                        }}
                      >
                        {field?.type === "radio" ? (
                          <Radio
                            sx={{ marginTop: "8px", marginLeft: "8px" }}
                            checked={
                              surveyForm ? surveyForm[idx][field.id] : ""
                            }
                            onChange={(e: any) =>
                              onChangeAction(e, idx, field?.valueFormat)
                            }
                            name={field?.id}
                            id={field?.id}
                            color="primary"
                            disabled={disabledAction}
                          />
                        ) : field?.type === "checkbox" ? (
                          <Checkbox
                            sx={{
                              marginTop: "2px",
                              marginLeft: "2px",
                              padding: "4px",
                            }}
                            checked={
                              surveyForm ? surveyForm[idx]?.[field.id] : false
                            }
                            onChange={(e: any) =>
                              onChangeAction(e, idx, field?.valueFormat)
                            }
                            name={field?.id}
                            id={field?.id}
                            color="primary"
                            disabled={disabledAction}
                          />
                        ) : field?.type === "list" ? (
                          <>
                            {surveyForm[idx]?.isLeave && (
                              <Box sx={{ padding: "1px 4px" }}>Leave</Box>
                            )}

                            {surveyForm[idx]?.isWeee && (
                              <Box sx={{ padding: "1px 4px" }}>Company</Box>
                            )}

                            {surveyForm[idx]?.isCust && (
                              <Box sx={{ padding: "1px 4px" }}>Cust</Box>
                            )}
                          </>
                        ) : (
                          <FormField
                            // key={field.id}
                            onPaste={(e: any) => e.preventDefault()}
                            onKeyDown={(event: any) => {
                              console.log(
                                "event log-",
                                event,
                                event.target.value + event.key,
                              );
                              if (
                                event.keyCode === 8 ||
                                event.keyCode === 9 ||
                                event.keyCode === 37 ||
                                event.keyCode === 38 ||
                                event.keyCode === 39 ||
                                event.keyCode === 40 ||
                                event.keyCode === 18 ||
                                event.keyCode === 17 ||
                                event.ctrlKey
                              )
                                return event;
                              if (
                                field?.patternAllowed &&
                                !field?.patternAllowed.test(event.key)
                              ) {
                                event.preventDefault();
                              } else if (
                                field?.patternAllowed &&
                                !field?.patternAllowed.test(
                                  event.target.value + event.key,
                                )
                              ) {
                                event.preventDefault();
                              }
                            }}
                            {...{
                              ...field,
                              counterWidth: "16px !important",
                              counterHeight: "16px !important",
                              counterBox: "0px !important",
                              counterSign: "10px !important",
                              disabled:
                                isCustomer && field?.id === "ft3"
                                  ? true
                                  : (isResourcesTab &&
                                      field?.id === "linkedItem") ||
                                    (isMaterialsTab &&
                                      field?.id === "linkedItem") ||
                                    (isMaterialsTab &&
                                      field?.id === "sortOrder") ||
                                    (isMaterialsTab && field?.id === "item") ||
                                    (field?.id === "hviValue" &&
                                      surveyForm[idx]?.isHVI === false) ||
                                    field?.isDisabled ||
                                    disabledAction,
                              id: field?.id,
                              value: surveyForm
                                ? field?.id === "hviValue" &&
                                  surveyForm[idx]?.isHVI === false
                                  ? ""
                                  : surveyForm[idx][field.id]
                                : "",
                              variant: "outlined", // Adding this variant prop
                              isNonMarginTop: true,
                              ...(field?.type === "select" && {
                                options: linkedItems,
                              }),
                              InputProps: {
                                ...field?.inputProps,
                                // autocomplete: "off",
                                sx: {
                                  // ...field?.inputProps?.sx,
                                  padding: "2px 4px",
                                  height: "20px",
                                },
                              },

                              onChange: (e: any) =>
                                onChangeAction(e, idx, field?.valueFormat),
                              onBlur: (e: any) =>
                                onBlurAction(e, idx, field?.valueFormat),
                              onIncrement: () => handleIncrement(idx, field.id),
                              onDecrement: () => handleDecrement(idx, field.id),
                              error:
                                tableHeadding?.[4]?.label === "Move Equipment"
                                  ? Boolean(
                                      error &&
                                      field?.id === "item" &&
                                      error?.[idx],
                                    )
                                  : Boolean(
                                      typeof error?.[idx] === "object"
                                        ? error?.[idx]?.[field?.id] ||
                                            error?.[idx]?.row
                                        : error?.[idx],
                                    ),
                            }}
                          />
                        )}
                      </TableCell>
                    );
                  })}
                {removeRow ? (
                  <TableCell sx={{ fontSize: "10px", padding: "8px 10px" }}>
                    {/* {!disabledAction ? (
                      <CustomButton
                        title="Reset"
                        variant="outlined"
                        sx={{marginRight:'2px'}}
                        onClick={() => removeRow(idx)}
                      />
                    ) : null} */}
                    {/* clear functionality */}
                    {!disabledAction ? (
                      <CustomButton
                        sx={{
                          fontSize: "13px",
                          padding: "0px",
                        }}
                        title="Reset"
                        variant="outlined"
                        onClick={() => clearRow(idx)}
                      />
                    ) : null}
                  </TableCell>
                ) : null}
              </TableRow>
            </>
          ))
        ) : (
          <TableRow>
            <TableCell
              colSpan={9}
              sx={{
                textAlign: "center",
                background: "#ffecec",
              }}
            >
              There must be at least one survey item.
            </TableCell>
          </TableRow>
        )}
      </>
    </TableDesign>
  );
};

export default RenderSurveyTable;
